import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ChoosePlumbingOptionWrapper = styled.div`
  padding-bottom: 2rem!important;
`;
const ChoosePlumbingOptionOptionGroup = ({ children }) => children.length > 0 && (
  <ChoosePlumbingOptionWrapper
    id="ChoosePlumbingOption"
    data-template="ChoosePlumbingOptionOptionGroup"
    className="card-content flex-wrap-dependent-options"
  >
    <div className="row-header">
      <div className="row-header__title">
        <div className="sui-h2-bold sui-line-clamp-unset sui-text-primary">
          Plumbing Services
        </div>
      </div>
    </div>
    <div className="headless">
      {children}
    </div>
  </ChoosePlumbingOptionWrapper>
);

ChoosePlumbingOptionOptionGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChoosePlumbingOptionOptionGroup;
